import React, { useCallback } from 'react';

import Button from '@wconcept/wconcept-ui/components/atoms/Button';
import { IconClose2 } from '@wconcept/wconcept-ui/components/atoms/svg';
import Title from '@wconcept/wconcept-ui/components/atoms/Title';

import * as S from './style';

interface IProps {
  onClose?: () => void;
  onSubmit?: () => void;
  // onSubmit: (isAgreed: boolean) => void;
  value: {
    isIPhoneXApp: boolean;
    isDesktop: boolean;
  };
}

const AgreeModal = ({ onSubmit, onClose, value }: IProps) => {
  const { isIPhoneXApp, isDesktop } = value;

  // EVENT HANDLER
  const handleSubmit = useCallback(() => {
    if (typeof onSubmit === 'function') onSubmit();
  }, [onSubmit]);

  // EVENT HANDLER : 닫기
  const handleClose = useCallback(() => {
    if (typeof onClose === 'function') onClose();
  }, [onClose]);

  // ITEM RENDERER : getAgreeContents
  const getAgreeContents = () => (
    <div className="agree_ctns">
      <table>
        <thead>
          <tr>
            <th>구분</th>
            <th>수집항목</th>
            <th>이용목적</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>기타 서비스</td>
            <td>휴대폰 번호</td>
            <td>라이브 알림 발송</td>
          </tr>
        </tbody>
      </table>
      <ul className="unorder-list">
        <li>
          개인정보의 보유 및 이용 기간 : 회원탈퇴 시 또는 법정 의무 보유기간
        </li>
        <li>
          이용자는 동의를 거부할 권리가 있습니다. 단, 동의를 거부할 경우 서비스
          이용이 불가합니다.
        </li>
      </ul>
    </div>
  );

  return (
    <S.AgreeModal className={isIPhoneXApp ? 'is-old-app-iphonex' : ''}>
      <S.BoxCont>
        <Title level={3}>개인정보의 수집 및 이용안내(필수)</Title>
        {getAgreeContents()}
      </S.BoxCont>
      <S.BoxBtn className="area-btn">
        <Button className="btn-bottom st-close" onClick={handleClose}>
          취소
        </Button>
        <Button className="btn-bottom st-confirm" onClick={handleSubmit}>
          동의
        </Button>
      </S.BoxBtn>
      {isDesktop && (
        <Button className="btn-close" onClick={handleClose}>
          <IconClose2 />
        </Button>
      )}
    </S.AgreeModal>
  );
};

export default AgreeModal;
